<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="suggestion-kosiwons-item" :class="{grid: viewType === 'grid', row: viewType === 'row'}">
    <div>
      <div class="kosiwons-image-wrapper">
        <img :src="kosiwon.thumbnail_url ? kosiwon.thumbnail_url : SampleImage" />
      </div>
      <kosiwon-information-fragments
        :kosiwon-information="kosiwon"
      />
    </div>
  </div>
</template>

<script>
  import KosiwonInformationFragments from '../Kosiwons/KosiwonInformationFragments'
  import SampleImage from '../../assets/images/list-thumbnail-none.png'
  export default {
    name: 'PackageListItem',
    components: {KosiwonInformationFragments},
    props: {
      kosiwon: {
        type: Object,
        default: () => {}
      },
      viewType: {
        type: String,
        default: 'grid'
      }
    },
    data () {
      return {
        SampleImage
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";
  .suggestion-kosiwons-item {
    cursor: pointer;
    &.row {
      flex: 1;
      padding: 0 1rem;
      max-width: 25%;
      min-width: 25%;
      box-sizing: border-box;
    }
    .kosiwons-image-wrapper {
      height:100%;
      width: 100%;
      overflow: hidden;
      position: relative;
      padding-top: 66%;

      img {
        position: absolute;
        margin: auto;
        min-height: 100%;
        min-width: 100%;
        width: 100%;
        /* For the following settings we set 100%, but it can be higher if needed
        See the answer's update */
        left: -100%;
        right: -100%;
        top: -100%;
        bottom: -100%;
      }
    }

    &.grid {
      width: 31%;
      margin: 2% 1%;

      &:nth-child(3n+1) {
        margin: 2% 1% 2% 0;
      }

      &:nth-child(3n+3) {
        margin: 2% 0 2% 1% ;
      }

      &:nth-child(-n+3) {
        margin-top: 0;
      }

      &:nth-child(n+4):nth-child(-n+6) {
        margin-bottom: 0;
      }
    }

    .row {

    }
  }
</style>


<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .suggestion-kosiwons-item {
      max-width: calc(50%);
      min-width: calc(50%);
      width: calc(50%);
      flex: 1;

      &.row {
        max-width: calc(50%);
        min-width: calc(50%);
        width: calc(50%);
      }

      &:nth-child(2n) {
        padding: 0 0 0 0.5rem;
      }

      &:nth-child(2n-1) {
        padding: 0 0.5rem 0 0;
      }
      .kosiwons-image-wrapper{
        /*padding-top: 0;*/
        img {
          position: absolute;
          margin: auto;
          /*margin: auto;*/
          /*min-height: 100%;*/
          /*min-width: 100%;*/
          /* For the following settings we set 100%, but it can be higher if needed
          See the answer's update */
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          /*width:100%;*/
          /*height: 100%;*/
          max-height: 11rem;
          /*max-width: 50%;*/
          /*left: 0;*/
          /*right: 0;*/
          /*top: 0;*/
          /*bottom: 0;*/
          /* width: 100%; */
          /* height: 100%; */
          /*min-width: 50%;*/
        }
      }
    }
  }
</style>


